import snippets from './snippets';

const entity = snippets('mmsSnippets');

const reducer = entity.reducer;
export {reducer as default, entity};